export default {
  ADOBE_IDENTIFIER: 'aam_uuid',
  RSI_SEGMENTS: 'rsi_segs',
};
